import { DetailedHTMLProps, FC, InputHTMLAttributes, ReactNode } from "react";
import { InputBaseProps, InputContainer } from ".";
import classNames from "classnames";

interface props extends InputBaseProps {
  borderless?: boolean;
  inputProps?: DetailedHTMLProps<
    InputHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >;
}

export const TextArea: FC<props> = (props) => {
  return (
    <InputContainer {...props}>
      <div
        className={classNames(
          "flex items-center rounded-[10px] border overflow-hidden",
          {
            "border-none": props.borderless,
            "border-error bg-error-light": props.hasError,
            "border-gray-300 bg-white": !props.hasError,
          }
        )}
      >
        <textarea
          {...props.inputProps}
          className="flex-1 bg-transparent text-sm h-28 p-2 outline-none resize-none"
        />
      </div>
    </InputContainer>
  );
};
